webpackJsonp([54901965233954],{

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/services_bd.06c7c879.jpg";

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(23);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _services_bd = __webpack_require__(606);
	
	var _services_bd2 = _interopRequireDefault(_services_bd);
	
	var _ShareButtons = __webpack_require__(31);
	
	var _ShareButtons2 = _interopRequireDefault(_ShareButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageMeta = {
	  title: "Brilliant Distinctions",
	  desc: '"BRILLIANT SAVINGS. BRILLIANT REWARDS."'
	};
	var AboutPage = function AboutPage(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style, className: 'page' },
	    _react2.default.createElement(_PageHeader2.default, { bgPhoto: _services_bd2.default, contain: true, styles: { backgroundColor: "#e9e9e9" } }),
	    typeof window !== 'undefined' && _react2.default.createElement(_ShareButtons2.default, { location: location.href, desc: pageMeta.desc }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title-bar' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          pageMeta.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          pageMeta.desc
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Brilliant Distinctions is a loyalty program whereby as a member, you\u2019ll earn points on select Allergan products that will help you save big on future purchases. You will also gain access to valuable member \u2013 only content, including special offers and beauty tips. Sign up on the day of your first treatment to get started!'
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-brilliant-distinctions-js-db3fa601c7901b8b2377.js